import { Box, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { PdfAuthorNote } from "./pdf-author-note"
import { PdfTaskOrderHeader } from "./pdf-task-order-header"
import { PdfTaskOrderChangesRow } from "./pdf-task-order-changes-row"

export function PdfTaskOrderChangesSection({ section }) {
    const hasItems = Boolean(section?.items?.length)
    const hasNote = Boolean(section?.note?.content)
    if (!hasItems && !hasNote) return null

    return (
        <Box component="tbody" sx={{ pageBreakBefore: "always", breakBefore: "page" }}>
            <Box component="tr">
                <Box component="td" colSpan={2} sx={sectionHeadingCellSx}>
                    <Typography sx={{ fontWeight: 700, fontSize: "11px", color: "#1f2937" }}>
                        {section.title}
                    </Typography>
                </Box>
            </Box>
            <If value={hasItems}>
                <Box component="tr">
                    <Box component="td" colSpan={2} sx={{ p: 0, pt: "14px", pb: hasNote ? "12px" : "24px" }}>
                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "1fr 180px",
                            }}
                        >
                            <PdfTaskOrderHeader label="Task Title" />
                            <PdfTaskOrderHeader label="Previous Order" align="right" />
                            <Repeat list={section.items} item={<PdfTaskOrderChangesRow />} />
                        </Box>
                    </Box>
                </Box>
            </If>
            <If value={hasNote}>
                <Box component="tr" sx={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                    <Box component="td" colSpan={2} sx={{ p: 0, pt: hasItems ? 0 : "14px", pb: "24px" }}>
                        <PdfAuthorNote note={section.note} />
                    </Box>
                </Box>
            </If>
        </Box>
    )
}

const sectionHeadingCellSx = {
    p: 0,
    pb: "12px",
    borderBottom: "1px solid #d7dce2",
}
